import { motion } from "framer-motion";

export default function SceneOrb() {
  return (
    <div className="relative mx-auto flex h-[320px] w-full max-w-[480px] items-center justify-center rounded-[2rem] border border-white/10 bg-white/5 p-6 shadow-[0_30px_80px_rgba(255,122,61,0.18)] backdrop-blur-xl">
      <div className="absolute inset-6 rounded-full bg-[radial-gradient(circle,_rgba(255,122,61,0.3),_transparent_65%)] blur-3xl" />
      <motion.div
        animate={{ rotate: [0, 360], y: [0, -10, 0], x: [0, 8, -6, 0] }}
        transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
        className="relative h-56 w-56 rounded-full border border-white/20 bg-gradient-to-br from-orange-400 via-orange-500 to-fuchsia-600 shadow-[0_25px_60px_rgba(255,122,61,0.3)]"
      >
        <div className="absolute inset-4 rounded-full border border-white/30" />
        <div className="absolute inset-8 rounded-full border border-white/20" />
        <motion.div
          animate={{ rotate: [0, -360] }}
          transition={{ duration: 10, repeat: Infinity, ease: "linear" }}
          className="absolute left-1/2 top-1/2 h-24 w-24 -translate-x-1/2 -translate-y-1/2 rounded-full border border-white/25 bg-slate-950/50"
        />
        <motion.div
          animate={{ scale: [1, 1.08, 1] }}
          transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
          className="absolute left-1/2 top-1/2 h-16 w-16 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white/20"
        />
      </motion.div>
    </div>
  );
}
